// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopPortableBankCardControllerActivateBankCardData } from './EshopPortableBankCardControllerActivateBankCardData.gen';
import type { EshopPortableBankCardControllerActivateBankCardErrors } from './EshopPortableBankCardControllerActivateBankCardErrors.gen';
import type { EshopPortableBankCardControllerActivateBankCardResponses } from './EshopPortableBankCardControllerActivateBankCardResponses.gen';
import type { EshopPortableBankCardControllerBlockBankCardData } from './EshopPortableBankCardControllerBlockBankCardData.gen';
import type { EshopPortableBankCardControllerBlockBankCardErrors } from './EshopPortableBankCardControllerBlockBankCardErrors.gen';
import type { EshopPortableBankCardControllerBlockBankCardResponses } from './EshopPortableBankCardControllerBlockBankCardResponses.gen';
import type { EshopPortableBankCardControllerFinishTokenizationData } from './EshopPortableBankCardControllerFinishTokenizationData.gen';
import type { EshopPortableBankCardControllerFinishTokenizationErrors } from './EshopPortableBankCardControllerFinishTokenizationErrors.gen';
import type { EshopPortableBankCardControllerFinishTokenizationResponses } from './EshopPortableBankCardControllerFinishTokenizationResponses.gen';
import type { EshopPortableBankCardControllerInitTokenizationData } from './EshopPortableBankCardControllerInitTokenizationData.gen';
import type { EshopPortableBankCardControllerInitTokenizationErrors } from './EshopPortableBankCardControllerInitTokenizationErrors.gen';
import type { EshopPortableBankCardControllerInitTokenizationResponses } from './EshopPortableBankCardControllerInitTokenizationResponses.gen';
import type { Options } from './Options.gen';

export class EshopPortableBankCardController {
    /**
     * Init a tokenization of bank portable card.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CANNOT_INIT_TOKENIZATION** - Tokenization cannot be initialized.
     */
    public static initTokenization<ThrowOnError extends boolean = false>(options: Options<EshopPortableBankCardControllerInitTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopPortableBankCardControllerInitTokenizationResponses, EshopPortableBankCardControllerInitTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-bank-cards/init-tokenization',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Finish a tokenization of bank portable card.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CARD_APPLICATION** - Card application is invalid or does not exist.<br>
     * + **CHIP_NUMBER_NOT_UNIQUE** - Chip number already exists.<br>
     * + **CARD_HAS_UNPROCESSED_TRANSACTIONS** - Card has unprocessed transactions. Upload all transactions to card first.<br>
     * + **CANNOT_FINISH_TOKENIZATION** - Tokenization cannot be finished.
     */
    public static finishTokenization<ThrowOnError extends boolean = false>(options: Options<EshopPortableBankCardControllerFinishTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopPortableBankCardControllerFinishTokenizationResponses, EshopPortableBankCardControllerFinishTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-bank-cards/finish-tokenization',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Block active bank card.
     */
    public static blockBankCard<ThrowOnError extends boolean = false>(options: Options<EshopPortableBankCardControllerBlockBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopPortableBankCardControllerBlockBankCardResponses, EshopPortableBankCardControllerBlockBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-bank-cards/{id}/block',
            ...options
        });
    }
    
    /**
     * Activate blocked bank card.
     */
    public static activateBankCard<ThrowOnError extends boolean = false>(options: Options<EshopPortableBankCardControllerActivateBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopPortableBankCardControllerActivateBankCardResponses, EshopPortableBankCardControllerActivateBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-bank-cards/{id}/activate',
            ...options
        });
    }
}
